import templateUrl from 'servicestack/tags/tags-viewer.htm'
import basicController from 'servicestack/basic.controller.properties'

class controller {
    constructor() {
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit() {
        const $ctrl = this;
        if (!Array.isArray($ctrl.tagKinds)) {
            $ctrl.tagKinds = Object.keys($ctrl.tags);
        }
    }
}

export default {
    bindings: {
        shard: '@',
        tags: '<ngModel',
        tagKinds: '<'
    },
    controller,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};